import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { ProjectChecklistCenterModal } from '@components/ProjectDetail/ProjectChecklist/ProjectChecklistCenterModal';
import { Box, Text } from '@components/Restyle/index';
import Icon from '@components/shared/Icon/Icon';

export const WebErrorModal = ({
  onClose,
  onGotIt,
  modalVisible,
  errorTitle,
  errorMsg,
  buttonTitle,
}: {
  onClose: () => void;
  onGotIt: () => void;
  errorTitle: string;
  errorMsg: string;
  buttonTitle?: string;
  modalVisible: boolean;
}) => {
  const { t } = useTranslation('models');

  return (
    <ProjectChecklistCenterModal
      contentNode={
        <Box py='m' px='l'>
          <Box flexDirection='row' marginBottom='l' alignItems='center'>
            <Text
              flex={1}
              style={{ alignSelf: 'flex-start' }}
              variant='labelLarge'
              color='textPrimary'>
              {errorTitle}
            </Text>
            <TouchableOpacity style={{ outline: 'none' }} onPress={onClose}>
              <Icon name='X' variant='m' />
            </TouchableOpacity>
          </Box>

          <Text
            marginBottom='l'
            variant='bodySecondary'
            color='textSecondary'
            style={{ alignSelf: 'flex-start' }}>
            {errorMsg}
          </Text>

          <TouchableOpacity
            accessibilityLabel={
              buttonTitle ?? t('models:projects.checklist.gotIt')
            }
            style={{ outline: 'none' }}
            onPress={onGotIt}>
            <Box
              width={125}
              height={48}
              borderRadius='xs'
              backgroundColor='black'
              justifyContent='center'
              alignSelf='flex-end'
              alignItems='center'>
              <Text variant='labelSmall' color='white'>
                {buttonTitle ?? t('models:projects.checklist.gotIt')}
              </Text>
            </Box>
          </TouchableOpacity>
        </Box>
      }
      onClose={onClose}
      visible={modalVisible}
    />
  );
};
